import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

const Navigation = ({ isMenuOpen, closeMenu }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language, changeLanguage } = useLanguage();

  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [expandedMenu, setExpandedMenu] = useState(null);

  const menuItems =
    language === "en"
      ? [
          {
            title: "Company introduction",
            path: "/en/about",
            subItems: [
              { title: "Greeting", path: "/en/about/greeting" },
              { title: "History", path: "/en/about/history" },
            ],
          },
          {
            title: "Agribusiness Dept",
            path: "/en/products",
            subItems: [
              { title: "Crop Shredder", path: "/en/products/shredder" },
              { title: "Supplies", path: "/en/products/supply" },
              { title: "Disinfectants", path: "/en/products/cleaner" },
              { title: "Shading/Cleaning", path: "/en/products/sanitizer" },
              { title: "Greenhouse Opener", path: "/en/products/opener" },
              { title: "Machinery", path: "/en/products/machine" },
              { title: "Construction", path: "/en/portfolio" },
              { title: "Maintenance", path: "/en/products/maintenance" },
              { title: "RatelParkgolf", path: "/en/products/golf" },
            ],
          },
          {
            title: "Advanced Materials Dept",
            path: "/en/products/ceramic",
            subItems: [
              { title: "Lead-Free Piezoelectric Ceramic Materials", path: "/en/products/ceramic" },
              { title: "Applied Products", path: "/en/products/application" },
            ],
          },
          {
            title: "K-Defense Dept",
            path: "/en/products/stealth",
            subItems: [
              { title: "Stealth Coatings", path: "/en/products/stealth" },
              { title: "Self-Powered Heating Insoles", path: "/en/products/insoles" },
            ],
          },
          {
            title: "Q&A",
            path: "/en/board",
            subItems: [
              { title: "Inquiry", path: "/en/board/contact" },
              { title: "Notice", path: "/en/board/notice" },
            ],
          },
          {
            title: "Release",
            path: "/en/releases",
            subItems: [],
          },
        ]
      : [
          {
            title: "회사소개",
            path: "/about",
            subItems: [
              { title: "인사말", path: "/about/greeting" },
              { title: "히스토리", path: "/about/history" },
            ],
          },
          {
            title: "농산업사업부",
            path: "/products",
            subItems: [
              { title: "작물파쇄", path: "/products/shredder" },
              { title: "소모자재", path: "/products/supply" },
              { title: "소독제", path: "/products/cleaner" },
              { title: "차광/세척제", path: "/products/sanitizer" },
              { title: "온실개폐장치", path: "/products/opener" },
              { title: "기계장비", path: "/products/machine" },
              { title: "시공", path: "/portfolio" },
              { title: "유지보수", path: "/products/maintenance" },
              { title: "라텔파크골프", path: "/products/golf" },
            ],
          },
          {
            title: "첨단소재·부품사업부",
            path: "/products/ceramic",
            subItems: [
              { title: "무연압전세라믹소재", path: "/products/ceramic" },
              { title: "응용제품", path: "/products/application" },
            ],
          },
          {
            title: "K-방산 사업부",
            path: "/products/stealth",
            subItems: [
              { title: "스텔스 도료", path: "/products/stealth" },
              { title: "자기발전 발열인솔", path: "/products/insoles" },
            ],
          },
          // {
          //   title: "시공사례",
          //   path: "/portfolio",
          //   subItems: [],
          // },
          {
            title: "Q&A",
            path: "/board",
            subItems: [
              { title: "견적문의", path: "/board/contact" },
              { title: "공지사항", path: "/board/notice" },
            ],
          },
          {
            title: "릴리즈",
            path: "/releases",
            subItems: [],
          },
        ];

  const toggleSubMenu = (index) => {
    if (expandedMenu === index) {
      setExpandedMenu(null);
    } else {
      setExpandedMenu(index);
    }
  };

  // 메뉴 항목 클릭 시 모바일 메뉴 닫기
  const handleMenuClick = () => {
    closeMenu(); // 조건 없이 항상 메뉴를 닫도록 수정
  };

  const handleLinkClick = (path) => {
    setHoveredMenu(null);
    setExpandedMenu(null);
    handleMenuClick();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  const handleMainMenuClick = (e, index, hasSubItems, path) => {
    if (hasSubItems && window.innerWidth <= 992) {
      e.preventDefault();
      toggleSubMenu(index);
    } else {
      // 서브메뉴가 없거나 데스크톱 환경에서는 링크로 이동
      handleLinkClick(path);
    }
  };

  // 언어 전환 핸들러
  const handleLanguageChange = (lang) => {
    const currentPath = location.pathname;
    let newPath;

    if (lang === "en") {
      // 한국어에서 영어로 전환
      if (currentPath.startsWith("/en")) {
        newPath = currentPath; // 이미 영어 경로
      } else {
        // URL 첫 부분에 /en 추가
        newPath = "/en" + currentPath;
      }
    } else {
      // 영어에서 한국어로 전환
      if (currentPath.startsWith("/en")) {
        // /en 접두사 제거
        newPath = currentPath.substring(3);
        if (newPath === "") newPath = "/"; // 루트 경로 처리
      } else {
        newPath = currentPath; // 이미 한국어 경로
      }
    }

    // 언어 상태 변경
    changeLanguage(lang);

    // 새 경로로 이동
    navigate(newPath);

    // 메뉴 닫기
    handleMenuClick();
  };

  // 현재 경로가 메뉴 항목 경로와 일치하는지 확인하는 함수
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <nav className={`navigation ${isMenuOpen ? "open" : ""}`}>
      <ul className={`navigationUl ${language === "en" ? "navigationUlEn" : ""}`}>
        {menuItems.map((item, index) => (
          <React.Fragment key={index}>
            <li className="nav-item" onMouseEnter={() => window.innerWidth > 992 && setHoveredMenu(index)} onMouseLeave={() => window.innerWidth > 992 && setHoveredMenu(null)}>
              <div className="nav-link-container">
                <Link to={item.path} className={`nav-link ${isActive(item.path) ? "active" : ""}`} onClick={(e) => handleMainMenuClick(e, index, item.subItems.length > 0, item.path)}>
                  {item.title}
                </Link>
                {item.subItems.length > 0 && (
                  <button className="submenu-toggle" onClick={() => toggleSubMenu(index)} aria-label={`${item.title} 하위메뉴 ${expandedMenu === index ? "닫기" : "열기"}`}>
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 40 40"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transform: expandedMenu === index ? "rotate(180deg)" : "rotate(0deg)",
                        display: "block",
                        margin: "0 auto",
                      }}
                    >
                      <path d="M8 15 L20 27 L32 15" className="cls-1" stroke="#999999" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                )}
              </div>
              {item.subItems.length > 0 && (
                <div className={`dropdown ${hoveredMenu === index || expandedMenu === index ? "show" : ""}`}>
                  <ul className="dropdown-menu">
                    {item.subItems.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <Link to={subItem.path} className={`dropdown-link ${isActive(subItem.path) ? "active" : ""}`} onClick={handleMenuClick}>
                          <span className="bullet">•</span> {subItem.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
            {index < menuItems.length - 1 && <hr className="mobile-divider" />}
          </React.Fragment>
        ))}
      </ul>
      <div className="languageLink">
        <button className={language === "ko" ? "active" : ""} onClick={() => handleLanguageChange("ko")}>
          KR
        </button>
        |
        <button className={language === "en" ? "active" : ""} onClick={() => handleLanguageChange("en")}>
          EN
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
